module.exports = __webpack_public_path__ + "media/images/cross-e148a5dc21c9b426ec5dc9241ec0439b.png";